<template>
  <div>
    <el-upload
      ref="upload"
      class="avatar-uploader"
      style="text-align: center"
      action="/aaas-file/file/uploadFileRedis"
      :headers="config"
      :data="uploadObj"
      name="files"
      :disabled="isDetail"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :on-progress="handleLoading"
      :on-error="handleError"
      :before-upload="beforeAvatarUpload">
      <el-image v-if="imageUrl && !loading" :src="imageUrl" fit="cover" class="avatar"></el-image>
      <i v-if="!imageUrl && !loading" class="el-icon-plus avatar-uploader-icon" style="border: 1px dashed #7f7f7f"></i>
      <el-progress v-if="loading" class="upload-progress" type="circle" :percentage="uploadPercent"></el-progress>
    </el-upload>
  </div>
</template>

<script>
  import FileV2Api from "@/api/common/FileV2Api";
  import {mapGetters} from "vuex";
  export default {
    name: "img-upload",
    data(){
      return{
        loading:false,
        imageUrl:'',
        isUpload:false, //判断是否是自己手动上传
        uploadPercent:0,
      }
    },
    props:{
      uploadObj:{
        type:Object
      },
      isDetail:{
        type:Boolean,
        default:false
      },
    },
    computed: {
      ...mapGetters(["token"]),
      config: function () {
        return {"Authorization": this.token}
      },
      packageId: function () {
        return this.uploadObj.packageId
      },
      pageId(){
        return this.uploadObj.pageId
      },
    },
    methods:{
      //上传成功后
      handleAvatarSuccess(res, file) {
        this.loading = false
        if(res.code == 1){
          this.imageUrl = URL.createObjectURL(file.raw)
          this.uploadObj.packageId = res.data.packageId
          this.isUpload = true
        }else {
          if (this.uploadObj.packageId == '') {
            this.$refs.upload.clearFiles();
          } else {
            //回显之前的图片
            this.showImg()
          }
          this.$message.error('上传失败，请重新上传');
        }
      },
      //上传之前
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
        // const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传的图片只能是 JPG/JPEG/PNG 格式!');
        }
        // if (!isLt2M) {
        //   this.$message.error('上传的图片大小不能超过 2MB!');
        // }
        return isJPG;
      },
      //上传过程中
      handleLoading(event, file, fileList){
        this.loading = true
        this.uploadPercent = Number(file.percentage.toFixed(0))
      },
      //上传失败
      handleError(file, fileList) {
        this.loading = false
      },
      //显示图片
      showImg(){
        this.loading = true
        let data = {
          pageId: this.uploadObj.pageId,
          packageId: this.uploadObj.packageId
        }
        let fileV2Api = new FileV2Api();
        fileV2Api.listFile(data).then(res => {
          this.loading = false
          this.imageUrl = res.data[res.data.length - 1].fileUrl
        })
      },
    },
    created(){
      if(this.uploadObj.pageId && this.uploadObj.packageId){
        this.showImg()
      }
    },
    watch:{
      packageId:{
        handler(val, oldVal){
          if(!this.isUpload && val){
            this.showImg()
          }
        },
        deep:true
      },
      pageId:{
        handler(val, oldVal){
          if(!this.isUpload && val && this.uploadObj.packageId){
            this.showImg()
          }
        },
        deep:true
      },
    }
  }
</script>

<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #7f7f7f;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    text-align: center !important;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 124px;
    height: 124px;
    line-height: 124px;
    text-align: center;
  }
  .avatar {
    width: 124px;
    height: 124px;
    display: block;
  }
</style>
